import { render, staticRenderFns } from "./Redirects.vue?vue&type=template&id=ad47eb9c&"
import script from "./Redirects.vue?vue&type=script&lang=js&"
export * from "./Redirects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports